<template>
    <console-content max-width="1280">

        <v-row class="mt-3 mt-md-8 px-1" align="center">
            <v-col cols="auto" class="py-0 headline text-start">제휴업체 관리</v-col>
            <v-spacer/>
            <v-col cols="auto" class="py-0">
                <v-btn class="mr-1" color="secondary" rounded @click="showSearch = !showSearch">
                    <v-icon small class="mr-2">mdi-filter-variant</v-icon>검색필터
                </v-btn>
            </v-col>
        </v-row>
        
        <v-expand-transition>
            <v-card v-show="showSearch" class="elevation-1 mt-3 mx-1">
                <v-card-title class="subtitle-2 font-weight-bold pb-0">검색필터</v-card-title>
                <v-card-text>
                    <v-row align="center">
                        <v-col cols="12" sm="3" class="py-0">
                            <v-select v-model="filter.searchKey" :items="searchKeys" label="검색조건" placeholder=" " hide-details @input="filter.searchValue = null;"></v-select>
                        </v-col>
                        <v-col cols="12" sm="3" class="py-0">
                            <v-text-field v-model="filter.searchValue" label="검색어" placeholder=" " hide-details :disabled="!filter.searchKey" @keydown.enter="page = 1; search(true);"></v-text-field>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" rounded text @click="page = 1; search(true);">
                        <v-icon small class="mt-1 mr-2">mdi-magnify</v-icon>검색
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-expand-transition>
        
        <v-row class="mt-6 px-1">
            <v-col cols="auto" class="py-0"></v-col>
            <v-spacer />
            <v-col cols="auto" class="py-0">
                <v-btn color="white" class="green--text px-2 ml-1" @click="excel">
                    <v-icon class="mr-2">{{ mdiMicrosoftExcel }}</v-icon>엑셀다운로드
                </v-btn>
            </v-col>
        </v-row>

        <v-data-table :items="partners" :headers="partnersHeaders" hide-default-footer disable-sort class="mt-3 mx-1 elevation-1">
            <template v-slot:item.actions="{item}">
                <v-icon small @click="edit(item)">mdi-pencil</v-icon>
                <v-icon v-if="$hasScope(['root', 'admin'])" small class="ml-1" @click="remove(item)">mdi-delete</v-icon>
            </template>
            <template v-slot:item.createdAt="{item}">
                {{ $dayjs(item.createdAt).format("YYYY-MM-DD HH:mm:ss") }}
            </template>
        </v-data-table>

        <v-pagination v-model="page" :length="pageCount" total-visible="11" class="mt-3" @input="search(true)"/>

        <v-btn v-if="$hasScope(['root', 'admin'])" color="pink" fab fixed bottom right dark @click="create"><v-icon>mdi-pencil</v-icon></v-btn>

    </console-content>
</template>

<script>
import XLSX from "xlsx";
import api from "@/api";
import ConsoleContent from "@/pages/console/templates/ConsoleContent.vue";
import { mdiMicrosoftExcel } from "@mdi/js";

export default {
    components: {
        ConsoleContent
    },
    data(){
        return {
            mdiMicrosoftExcel,

            showSearch: true,

            filter: {
                searchKey: this.$route.query.searchKey || null,
                searchValue: this.$route.query.searchValue || null
            },

            searchKeys: [
                { text: ":: 전체 ::", value: null },
                { text: "업체명", value: "companyName" },
            ],

            page: +this.$route.query.page || 1,
            pageCount: 0,
            limit: 10,

            partners: [],
            partnersHeaders: [
                { text: "업체명", value: "companyName", align: "center", width: 200 },
                { text: "아이디", value: "username", align: "center" },
                { text: "코드", value: "code", align: "center" },
                { text: "이름(담당자)", value: "name", align: "center" },
                { text: "연락처(담당자)", value: "phone", align: "center" },
                { text: "이메일(담당자)", value: "email", align: "center" },
                { text: "생성일자", value: "createdAt", align: "center", width: 200 },
                { text: "actions", value: "actions", align: "center", width: 100 },
            ]
        }
    },
    mounted(){
        this.init();
    },
    methods: {
        async init(){
            await this.search();
        },

        async search(routable = false){
            if(routable){
                this.$router.push({
                    query: { ...this.filter, page: this.page }
                });
            }

            let { summary, partners } = await api.console.partners.gets({
                headers: {
                    skip: (this.page - 1) * this.limit,
                    limit: this.limit
                },
                params: this.filter
            });

            this.partners = partners;
            this.pageCount = Math.ceil(summary.totalCount / this.limit);
        },

        create(){
            this.$router.push(`/console/partners/create`);
        },

        edit(partner){
            this.$router.push(`/console/partners/${partner._id}`);
        },

        async remove(partner){
            if(confirm("정말 삭제하시겠습니까?")){
                await api.console.partners.delete(partner);
                alert("삭제되었습니다");
                this.search();
            }
        },

        async excel(){
            let { partners } = await api.console.partners.gets({
                headers: { limit: 0 },
                params: this.filter
            });

            var datas = [];
            partners.forEach(partner => {
                datas.push({
                    "업체명": partner?.companyName,
                    "아이디": partner?.username,
                    "코드": partner?.code,
                    "연락처": partner?.phone,
                    "이메일": partner?.email,
                    "생성일자": partner?.createdAt ? this.$dayjs(partner?.createdAt).format("YYYY-MM-DD HH:mm:ss") : "-"
                });
            });

            var workbook = new XLSX.utils.book_new();
            var worksheet = XLSX.utils.json_to_sheet(datas);

            XLSX.utils.book_append_sheet(workbook, worksheet, "제휴업체 목록");
            XLSX.writeFile(workbook, "제휴업체 목록.xlsx");
        }
    }
}
</script>